import React, {
    useEffect, useContext, useState, useCallback
} from 'react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { withRouter, Link } from 'react-router-dom';
import { ClaimService } from 'gw-capability-claim';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { InfoLabel } from '@jutro/components';
import { ProductUtil } from 'wnice-portals-util-react';
import { WniDateUtil } from 'wni-portals-util-js';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { PolicyTypeWithPCData } from 'gw-capability-claim-react'

import ClaimLobOptionsMenu from '../ClaimLobOptionsMenu/ClaimLobOptionsMenu';
import metadata from './ClaimListComponent.metadata.json5';
import styles from '../../pages/ClaimList/ClaimList.module.scss';
import claimsMessages from '../../Claims.messages';

import { Icon } from '@jutro/legacy/components';

import { IntlContext } from '@jutro/legacy/locale';

function ClaimListComponent({ history }) {
    const { authHeader } = useAuthentication();
    const [claimFilterOptions, setClaimFilterOptions] = useState([]);
    const [claimDataTable, setClaimDataTable] = useState([]);
    const [isLoading, setLoadingState] = useState(false);

    const [selectedClaimLOB, setSelectedClaimLOBe] = useState(undefined);
    const [searchFilter, setSearchFilter] = useState(undefined);
    const [isClosed, setIsClosed] = useState(true);
    const [policySummariesFromApi, setPolicySummariesFromApi] = useState([]);

    const translator = useTranslator();
    const intl = useContext(IntlContext);
    const { PolicyService } = useDependencies('PolicyService');

    // const getVendors = useCallback(
    //     (claim) => {
    //         if (!claim.vendors) {
    //             return [];
    //         }
    //         const normalizedLobCode = getNormalizedLOBName(claim.lineOfBusinessCode);
    //         const usedVendorTypes = vendorTypesForPolicyHolderByLob[normalizedLobCode] || [];

    //         const policyHolderVendors = claim.vendors.filter((vendor) => {
    //             let type = vendor.contactDTO.subtype;
    //             if (normalizedLobCode === 'ho') {
    //                 type = vendor.contactDTO.contactType;
    //             }
    //             return usedVendorTypes.indexOf(type) >= 0;
    //         });
    //         return policyHolderVendors;
    //     },
    //     [vendorTypesForPolicyHolderByLob]
    // );

    const processClaimsData = useCallback(
        (claimsData) => {
            if (!_.isEmpty(claimsData)) {
                let claimsArrayResult = claimsData;
                claimsArrayResult = claimsArrayResult.map((claimInfo) => {
                    const claims = {
                        product: claimInfo.lineOfBusinessCode,
                        claimNumber: claimInfo.claimNumber,
                        dateOfLoss: WniDateUtil.formatDateWithPattern(claimInfo.lossDate_Ext),
                        status: translator({
                            id: `typekey.ClaimState.${claimInfo.claimState}`,
                            defaultMessage: claimInfo.claimState
                        }),
                        policyNumber: claimInfo.policyNumber,
                        causeOfLoss: claimInfo.lossCause_Ext,
                        productCode: claimInfo.productCode_Ext,
                        policyType: claimInfo.policyType_Ext
                    };
                    return claims;
                });
                return claimsArrayResult;
            }
            return [];
        },
        [intl, translator]
    );

    const getPolicyCellType = useCallback(
        (rowData) => {
            return (
                <PolicyTypeWithPCData policySummariesFromApi={policySummariesFromApi} rowData={rowData} />
            )
        }, [policySummariesFromApi]
    )

    const getProductCode = useCallback((item) => {
        return ProductUtil.getProductName(item.productCode)
    }, []);

    const getClaimFilterOptions = (data) => {
        const options = data.map(item => ({
            policyType: item.policyType,
            productCode: getProductCode(item)
        }));
        const filterOptions = _.unionBy(options, item => item.policyType);
        filterOptions.unshift({
            policyType: translator(claimsMessages.allClaims),
            productCode: translator(claimsMessages.allClaims)
        })
        setClaimFilterOptions(filterOptions);
    }

    const getClaims = useCallback(
        (query, isInitLoad) => {
            const claimsPromise = ClaimService.getClaimSummaries(query, {}, authHeader);
            return claimsPromise
                .then((responseData) => {
                    const data = processClaimsData(responseData.items);
                    setClaimDataTable(data);
                    if(isInitLoad) {
                        getClaimFilterOptions(data);
                    }
                })
                
        },
        [authHeader, processClaimsData]
    );

    const loadClaimData = useCallback(
        (filters, isInitLoad) => {

            let claimStates = isClosed ? ['open', 'draft', 'closed'] : ['open', 'draft'];
            let policyType = selectedClaimLOB !== translator(claimsMessages.allClaims)
                ? selectedClaimLOB
                : undefined;
            let queryText = searchFilter;

            if (!_.isUndefined(filters)) {
                if (!_.isUndefined(filters.isClosed)) {
                    claimStates = filters.isClosed
                        ? ['open', 'draft', 'closed']
                        : ['open', 'draft'];
                }
                if (!_.isUndefined(filters.policyType)) {
                    policyType = filters.policyType !== translator(claimsMessages.allClaims)
                        ? filters.policyType
                        : undefined;
                }
                queryText = !_.isUndefined(filters.queryText) ? filters.queryText : queryText;
            }

            const query = {
                claimStates: claimStates,
                policyType: policyType,
                queryText: queryText
            };

            return getClaims(query, isInitLoad);
        },
        [selectedClaimLOB, searchFilter, isClosed, getClaims, translator]
    );

    useEffect(() => {
        setLoadingState(true);

        const loadClaimDataPromise = loadClaimData({}, true);
        setSelectedClaimLOBe(translator(claimsMessages.allClaims));
        let policySummaryPromise;
        if (policySummariesFromApi.length === 0) {
            policySummaryPromise = PolicyService.getAccountPolicySummaries(authHeader).then(
                setPolicySummariesFromApi
            );
        } else {
            policySummaryPromise = Promise.resolve(policySummariesFromApi);
        }
        Promise.all([loadClaimDataPromise, policySummaryPromise])
            .finally(() => {
                setLoadingState(false);
            });
        // Disabling to prevent continues re-rendering
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleFilterChange = useCallback(
        (value, id) => {
            if (id === 'LOBFilter' && value !== 'Filters') {
                setSelectedClaimLOBe(value);
                loadClaimData({ policyType: value });
            }
            if (id === 'searchFilter') {
                loadClaimData({ queryText: value });
            }
            if (id === 'closedFilter') {
                setIsClosed(value);
                loadClaimData({ isClosed: value });
            }
        },
        [loadClaimData]
    );

    const getCell = useCallback(
        (item, index, property) => {
            const toolTipMessage = {
                product: translator(claimsMessages.line),
                dateOfLoss: translator(claimsMessages.dateOfLossClaimDetail)
            };
            const dateFormatter = intl.formatDate(new Date(item[property.id]), { year: 'numeric', month: 'numeric', day: 'numeric' });
            return <span title={toolTipMessage[property.id]}>{dateFormatter}</span>;
        },
        [translator]
    );

    const getStatusCell = useCallback(
        (item, index, property) => {
            const titleMessage = translator(claimsMessages.claimStatus);
            const status = item[property.id];
            let typeStatus = 'success';

            if (status === translator({ id: 'typekey.ClaimState.draft', defaultMessage: 'draft' })) {
                typeStatus = 'warning';
            } else if (status === translator({ id: 'typekey.ClaimState.closed', defaultMessage: 'closed' })) {
                typeStatus = 'neutral';
            }

            return (
                <InfoLabel type={typeStatus} size="small" title={titleMessage[property.id]}>
                    {item[property.id]}
                </InfoLabel>
            );
        },
        [translator]
    );

    const getLink = useCallback(
        (item, index, property) => {
            const toolTipMessage = {
                policyNumber: translator(claimsMessages.policyNumberClaimDetail),
                claimNumber: translator(claimsMessages.claimNumber)
            };
            if (
                property.id === 'claimNumber'
                && item.status
                    === translator({ id: 'typekey.ClaimState.draft', defaultMessage: 'draft' })
            ) {
                const redirectpath = {
                    pathname: '/fnol-select-policy',
                    state: {
                        claimNumber: item[property.id],
                        redirectPath: '/claims',
                        claimStatus: item.status
                    }
                };
                return (
                    <Link
                        to={redirectpath}
                        className={styles.gwClaimsLinkContent}
                        title={toolTipMessage[property.id]}
                    >
                        {item[property.id]}
                    </Link>
                );
            }
            const redirectRoute = property.id === 'policyNumber'
                ? `/account-policy-details/${item[property.id]}`
                : `/claims/${item[property.id]}`;
            const redirectPath = {
                pathname: redirectRoute,
                state: {
                    claimNumber: item[property.id],
                    redirectPath: '/claims',
                    claimStatus: item.status
                }
            };
            return (
                <Link
                    to={redirectPath}
                    className={styles.gwClaimsLinkContent}
                    title={toolTipMessage[property.id]}
                >
                    {item[property.id]}
                </Link>
            );
        },
        [translator]
    );

    const getLossCauseCell = useCallback((data, index, property) => {
        const typeCode = data[property.id];
        if(typeCode) {
            const displayName = translator({ 
                id: `typekey.LossCause.${typeCode}`, 
                defaultMessage: `typekey.LossCause.${typeCode}`
            });
            return displayName;
        }
    },
    [translator]);

    const handleFileClick = useCallback(() => {
        return history.push({
            pathname: '/fnol-select-policy',
            state: {
                redirectPath: '/claims'
            }
        });
    }, [history]);

    const overrides = {
        claimListTableLoader: {
            loaded: !isLoading
        },
        claimTable: {
            data: claimDataTable,
            visible: !isLoading
        },
        searchFilter: {
            onValueChange: setSearchFilter,
            value: searchFilter,
            onEnter: () => {
                handleFilterChange(searchFilter, 'searchFilter');
            },
            actionFn: () => {
                handleFilterChange(searchFilter, 'searchFilter');
            }
        },
        noDataMessage: {
            visible: _.isEmpty(claimDataTable) && !isLoading,
            content: translator(claimsMessages.noClaimsResult)
        },
        claimLobOptionsMenu: {
            values: claimFilterOptions,
            handleFilterChange: handleFilterChange,
            isClosed: isClosed,
            selectedClaimLOB: selectedClaimLOB,
            isShowClosedClaimFilter: true
        }
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getCell: getCell,
            getLink: getLink,
            getProductCode: getPolicyCellType,
            getLossCauseCell: getLossCauseCell,
            getStatusCell: getStatusCell,
            handleFilterValue: handleFilterChange,
            handleClosedClaims: setIsClosed,
            handleFileClick: handleFileClick
        },
        resolveComponentMap: {
            claimloboptionsmenu: ClaimLobOptionsMenu
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

export default withRouter(ClaimListComponent);
